import MiddleConnectorIcon from './MiddleConnectorIcon';
import SmoothConnector from './SmoothConnector';
import SteepConnector from './SteepConnector';

const width = 80;
const height = 50;

interface ConnectorIconProps {
    index: number;
    count: number;
    isMirrored?: boolean;
    isFlipped?: boolean;
}
function ConnectorIcon({ index, count, isMirrored, isFlipped }: ConnectorIconProps) {
    let transform = '';
    if (isMirrored) {
        transform += 'rotateY(180deg)';
    }
    if (isFlipped) {
        if (transform.length > 0) {
            transform += ' ';
        }
        transform += 'rotateX(180deg)';
    }
    if (transform.length === 0) {
        transform = 'unset';
    }
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            {count === 1 && (
                <MiddleConnectorIcon
                    style={{
                        width,
                        height,
                    }}
                />
            )}
            {count === 2 && index === 0 && (
                <SteepConnector
                    style={{
                        width,
                        height,
                        transform,
                    }}
                />
            )}
            {count === 2 && index === 1 && (
                <SteepConnector
                    style={{
                        width,
                        height,
                        transform,
                    }}
                />
            )}
            {count === 3 && index === 0 && (
                <SteepConnector
                    style={{
                        width,
                        height,
                        transform,
                    }}
                />
            )}
            {count === 3 && index === 1 && (
                <MiddleConnectorIcon
                    style={{
                        width,
                        height,
                    }}
                />
            )}
            {count === 3 && index === 2 && (
                <SteepConnector
                    style={{
                        width,
                        height,
                        transform,
                    }}
                />
            )}

            {count === 4 && index === 0 && (
                <SteepConnector
                    style={{
                        width,
                        height,
                        transform,
                    }}
                />
            )}
            {count === 4 && (index === 1 || index === 2) && (
                <SmoothConnector
                    style={{
                        width,
                        height,
                        transform,
                    }}
                />
            )}
            {count === 4 && index === 3 && (
                <SteepConnector
                    style={{
                        width,
                        height,
                        transform,
                    }}
                />
            )}
        </div>
    );
}

export default ConnectorIcon;
